<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-4 border-b border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0">
      <div class="flex items-center space-x-3">
        <span class="material-symbols-outlined text-xl text-primary">person</span>
        <h2 class="text-lg font-semibold text-gray-800">Personal Information</h2>
      </div>
      <router-link 
        to="/update-profile"
        class="w-full sm:w-auto inline-flex items-center justify-center space-x-2 text-primary hover:text-primary-dark bg-primary-lighter hover:bg-primary-light px-4 py-2 rounded-lg transition-all duration-200 font-medium"
      >
        <span class="material-symbols-outlined text-sm">edit</span>
        <span class="text-sm">Edit Profile</span>
      </router-link>
    </div>
    <div class="p-4 sm:p-6">
      <div class="space-y-6">
        <div class="grid gap-6">
          <!-- Full Name -->
          <div class="flex items-start space-x-4 p-4 bg-gradient-to-r from-primary/5 to-primary/10 rounded-xl border border-primary/20">
            <div class="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-sm">
              <span class="material-symbols-outlined text-primary text-xl">badge</span>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-500 text-left mb-1">Full Name</p>
              <p class="text-lg font-semibold text-gray-900 text-left break-words">
                {{ getDisplayName() }}
              </p>
            </div>
          </div>

          <!-- Email -->
          <div class="flex items-start space-x-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
            <div class="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-sm">
              <span class="material-symbols-outlined text-blue-600 text-xl">mail</span>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-500 text-left mb-1">Email Address</p>
              <p class="text-lg font-semibold text-gray-900 text-left break-all">{{ profile?.email }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInformationCard',
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  methods: {
    getDisplayName() {
      const firstName = this.profile?.name || '';
      const lastName = this.profile?.surname || '';
      
      if (firstName && lastName) {
        return `${firstName} ${lastName}`;
      } else if (firstName) {
        return firstName;
      } else if (lastName) {
        return lastName;
      } else {
        return 'Not provided';
      }
    }
  }
};
</script>

<style scoped>
/* Enhanced gradients and shadows */
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .space-y-6 > * + * {
    margin-top: 1.5rem;
  }
  
  .space-x-4 > * + * {
    margin-left: 1rem;
  }
  
  .gap-6 {
    gap: 1.5rem;
  }
}

/* Enhanced hover effects */
a:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Focus states */
a:focus {
  outline: 2px solid rgba(66, 153, 225, 0.5);
  outline-offset: 2px;
}

/* Text wrapping for long content */
.break-words {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.break-all {
  word-break: break-all;
}
</style>
